export const Container = {
  baseStyle: {
    minW: "full",
    pl: [2, 6],
    pr: [2, 6],
  },
}
